<template>

  <div
      v-for="product in products"
      v-if="products.length > 0"
      :class="{'col-lg-3  col-sm-4  col-6  mb-5': display === 'grid' }"
  >
    <product-item :display="display" :product="product" :is_wishlist_page="is_wishlist_page"/>
  </div>

  <div v-else>
    <div v-if="!isLoading" class="mt-5 mb-5 text-center text">
      <img class="img img-search m-auto" src="/shop/images/find.png" alt="Empty result">
      {{ in18['page_not_found_result'] }}
    </div>
    <div v-else class="loader"></div>
  </div>

  <catalog-pagination
      v-if="products.length > 0"
      :links="pagination.links"
      :meta="pagination.meta"
      @change-page="handleChangePage"
  />

</template>

<script>

import ProductItem from "../product-item/ProductItem.vue";
import CatalogPagination from "./CatalogPagination.vue";

export default {
  components: {
    ProductItem,
    CatalogPagination
  },
  props:      {
    isLoading:  Boolean,
    pagination: Object,
    display:    String,
    products:   Object,
    in18:       Object,
    is_wishlist_page: {
      type:    Boolean,
      default: false
    },
  },

  emits:   [
    'change-page'
  ],
  methods: {
    /**
     * Handle a change in the page number.
     * @param {number} page - The new page number.
     */
    handleChangePage(page) {
      // Emit an event to inform the parent component of the page change.
      this.$emit("change-page", page);
    },
  },
};
</script>
